import type { BloodPanelTest } from "../constants/clinical.js";

export type BloodFlag = "" | "Low" | "High" | "Normal";

// Ported from computeBloodFlag (source line 5950). Value outside [lln, uln]
// auto-flags Low/High; the user must then qualify NCS/CS (stored separately,
// see BloodSectionData._severity), never persisted as the flag itself.
export function computeBloodFlag(test: Pick<BloodPanelTest, "lln" | "uln">, val: string | number | null | undefined): BloodFlag {
  if (val === "" || val === null || val === undefined) return "";
  const n = typeof val === "number" ? val : parseFloat(val);
  if (Number.isNaN(n)) return "";
  if (test.lln !== null && n < test.lln) return "Low";
  if (test.uln !== null && n > test.uln) return "High";
  return "Normal";
}

export interface BloodPanelRowInput {
  key: string;
  value: string | number | null | undefined;
  severity?: string | null;
  comment?: string | null;
}

// Ported from validateBloodPanel (source line 5959): if severity is qualified
// "CS" (Cliniquement Significatif), a comment is mandatory. Returns the list of
// analyte keys missing a required comment.
export function validateBloodPanelComments(rows: BloodPanelRowInput[]): string[] {
  const issues: string[] = [];
  for (const row of rows) {
    if (row.severity === "CS" && !(row.comment ?? "").trim()) {
      issues.push(row.key);
    }
  }
  return issues;
}
